(function() {
    'use strict';
    angular.module('wbUtilities').directive('updateTitle', ['$transitions', '$timeout', '$filter', function ($transitions, $timeout, $filter) {
        return {
            link: function(scope, element) {

                    var initialTitle = element.text();

                    var listener = function(trans) {
                        let title;
                        let to = trans.$to();
                        let params = trans.params('to');

                        if (initialTitle) {
                            title = initialTitle + " | ";
                        } else {
                            title = 'Axos Invest | ';
                        }

                        if (to.data && to.data.pageTitle) {
                            title += to.data.pageTitle;
                        } else if(to.controller) {
                            title += getControllerName(to);
                        }

                        if (params.type) {
                            title += " - " + fixName(params.type);
                        }
                        if (params.page) {
                            title += " - " + fixName(params.page);
                        }
                        if (params.code) {
                            title += " - " + fixName(params.code);
                        }

                        $timeout(function() {
                            element.text(title);
                        }, 0, false);
                    };

                    $transitions.onSuccess({}, listener);

                    function getControllerName(to) {
                        if (to.controller && typeof to.controller === "string") {
                            var name = to.controller
                                            .replace("ControllerAurea","")
                                            .replace("Controller","");
                            name = fixName(name);
                            return name;
                        } else if (to.parent) {
                            return getControllerName(to.parent);
                        } else {
                            return "";
                        }
                    }

                    function fixName(name) {

                        if (/[a-z]/.test(name)) {
                            name = name.replace(/([A-Z])/g, ' $1'); //camel case
                        }
                        name = name.replace(/([-_])/g, ' '); //hyphen or underscore
                        name = $filter('ucwords')(name);
                        return name;
                    }

            }
            };
        }
    ])
})();
